import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setLemReports, setLemReportFailure } from '../state/action/lemAction';
import { GET_LEM_REPORTS } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getReports({
  projectNo, signed = '', startDate = '', endDate = '', page = '', limit = ''
}) {
  let status = 0;
  try {
    const projNo = encodeURIComponent(projectNo).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const res = yield fetch(`${BASE_URL}/project/get-lem-reports?project_numbers=${projNo}&report_status=${signed}&start_date=${startDate}&end_date=${endDate}&limit=${limit}&page=${page}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setLemReports({ response }));
  } catch (error) {
    yield put(setLemReportFailure());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* lemWatcher() {
  yield takeLatest(GET_LEM_REPORTS, getReports);
}

function* lemSagas() {
  yield all([
    call(lemWatcher),
  ]);
}

export default lemSagas;
